export default class VideoGtmEvent {
  constructor(options = {}){
    this._data = options.data;
    this._tech = options.tech;
  }

  bindEvents(){
    this.bindStart();
    this.bindAdStart();
    this.bindAdClick();
    this.bindLogoClicked();
    this.bindFullscreen();
    this.bindCinemaMode();
    this.bindBitrateChange();
    this.bindSubtitleClick();
    this.bindSubtitleChange();
  }

  data(){
    return this._data;
  }

  tech(){
    return this._tech;
  }

  bindStart(){
    this.tech().on('vp-video-start', function(e){
      dataLayer.push({
        "event" : "start",
        "vod_id" : e.id,
        "feature_name" : "vod.play",
        "feature_location" : "vod."+e.id,
        "playback_location" : e.embed == "false" ? "direct" : "embed"
      });
    });
  }

  bindAdStart(){
    this.tech().on('vp-video-adstart', function(e){
      dataLayer.push({
        "event" : "impression",
        "ads_id" : e.adUUID,
        "feature_location" : "pre-roll",
        "feature_name" : "ads.play",
        "ads_location" : "vod."+e.id,
        "playback_location" : e.embed == "false" ? "direct" : "embed"
      });
    });
  }

  bindAdClick(){
    this.tech().on('vp-video-adclick', function(e){
      dataLayer.push({
        "event" : "click",
        "ads_id" : e.adUUID,
        "feature_location" : "pre-roll",
        "feature_name" : "ads.play",
        "ads_location" : "vod."+e.id,
        "playback_location" : e.embed == "false" ? "direct" : "embed"
      });
    });
  }

  bindLogoClicked(){
    this.tech().on("vp-vidio-logo-clicked", function(e){
      dataLayer.push({
        "event" : "click",
        "feature_name" : "embed-watch now",
        "feature_location" : "vidio icon",
        "feature_type" : "vod."+e.id
      });
    });
  }

  bindFullscreen(){
    this.tech().on('vp-fullscreen-change', function(e){
      if(this.tech().plugin().instance().isFullscreen()) {
        dataLayer.push({
          "event" : "size",
          "video_id" : e.id,
          "feature_name" : "vod.play",
          "feature_location" : "fullsize",
          "playback_location" : e.embed == "false" ? "direct" : "embed"
        });
      }
    }.bind(this));
  }

  bindCinemaMode(){
    this.tech().on("vp-cinema-mode", function(e){
      dataLayer.push({
        "event" : "size",
        "video_id" : e.id,
        "feature_name" : "vod.play",
        "feature_location" : "cinema",
        "playback_location" : "direct"
      });
    });
  }

  bindBitrateChange(){
    this.tech().on("vp-bitrate-change", function(e){
      dataLayer.push({
        "event" : "click",
        "video_id" : this.data().videoId(),
        "feature_name" : "bitrate",
        "feature_location" : e.height,
        "playback_location" : this.data().embed() === "false" ? "direct" : "embed"
      });
    }.bind(this));
  }

  bindSubtitleClick(){
    this.tech().on("vp-subtitle-click", function(e){
      dataLayer.push({
        "event" : "impression",
        "video_id" : e.id,
        "feature_name" : "subtitle",
        "feature_location" : this.data().embed() === "false" ? "direct" : "embed",
        "playback_location" : this.data().embed() === "false" ? "direct" : "embed"
      });
    }.bind(this));
  }

  bindSubtitleChange(){
    this.tech().on("vp-subtitle-change", function(e){
      dataLayer.push({
        "event" : "click",
        "video_id" : e.id,
        "feature_name" : "subtitle",
        "feature_location" : e.track,
        "playback_location" : this.data().embed() === "false" ? "direct" : "embed"
      });
    }.bind(this));
  }
}
